module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-appbar', {
    staticClass: "syn-navbar",
    attrs: {
      "title": "Mes paramètres"
    }
  }, [_c('mu-flat-button', {
    staticClass: "syn-nav-button",
    attrs: {
      "href": '#' + _vm.routeBack,
      "icon": "arrow_back"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "syn-content"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "60",
      "desktop": "60"
    }
  }, [_c('mu-paper', {
    attrs: {
      "zDepth": 1,
      "rounded": ""
    }
  }, [_c('div', {
    staticClass: "card-toolbar color-black",
    staticStyle: {
      "background-color": "#eeeeee",
      "border": "1px solid #edf1f2"
    }
  }, [_c('span', {
    staticClass: "card-toolbar-title",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.87)"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "#/vouch"
    }
  }, [_vm._v("Affichage")])]), _vm._v(" "), _c('span', [_c('mu-icon', {
    attrs: {
      "value": "cached"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": "Début Matin",
      "labelFloat": "",
      "format": "24hr",
      "lazy": "",
      "okLabel": "Ok",
      "cancelLabel": "Annuler",
      "autoOk": ""
    },
    model: {
      value: (_vm.pref.morning),
      callback: function($$v) {
        _vm.pref.morning = $$v
      },
      expression: "pref.morning"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": "Début après-midi",
      "labelFloat": "",
      "format": "24hr",
      "lazy": "",
      "okLabel": "Ok",
      "cancelLabel": "Annuler",
      "autoOk": ""
    },
    model: {
      value: (_vm.pref.afternoon),
      callback: function($$v) {
        _vm.pref.afternoon = $$v
      },
      expression: "pref.afternoon"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "label": "Impression étiquette"
    },
    model: {
      value: (_vm.pref.sticker),
      callback: function($$v) {
        _vm.pref.sticker = $$v
      },
      expression: "pref.sticker"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "1",
      "title": "Oui"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "0",
      "title": "Non"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "label": "Nb lignes tableau"
    },
    model: {
      value: (_vm.pref.vouchLine),
      callback: function($$v) {
        _vm.pref.vouchLine = $$v
      },
      expression: "pref.vouchLine"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": 10,
      "title": "10"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 12,
      "title": "12"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 14,
      "title": "14"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 15,
      "title": "15"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 20,
      "title": "20"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 30,
      "title": "30"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 40,
      "title": "40"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "label": "Imprimer listing"
    },
    model: {
      value: (_vm.pref.printList),
      callback: function($$v) {
        _vm.pref.printList = $$v
      },
      expression: "pref.printList"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": 0,
      "title": "0 page"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 1,
      "title": "1 page"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 2,
      "title": "2 pages"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "label": "Démarrer edition sur"
    },
    model: {
      value: (_vm.pref.editStart),
      callback: function($$v) {
        _vm.pref.editStart = $$v
      },
      expression: "pref.editStart"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": 0,
      "title": "Expéditeur"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 1,
      "title": "Destinataire"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": 2,
      "title": "Détails"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "padding-top": "5px",
      "width": "100%"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "Enregistrer",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.savePref()
      }
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ee25d8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/User_prefs.vue
// module id = 436
// module chunks = 1